import axios from 'axios';
import API_BASE from '../apiBase';
import { getStoredUser, setStoredUser } from './userStorage';
import { getIdTokenSafe } from '../firebase';

export async function ensureUserBootstrapped() {
  const token = await getIdTokenSafe(false);
  if (!token) {
    return false;
  }

  if (getStoredUser()?.id) {
    return true;
  }

  try {
    await axios.post(`${API_BASE}/api/users/bootstrap`);
    const { data: me } = await axios.get(`${API_BASE}/api/users/me`);
    if (me?.id) {
      setStoredUser(me);
      return true;
    }
  } catch (error) {
    console.error('Failed to bootstrap user profile:', error);
  }

  return false;
}
